import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Button } from "./ui/button";
import { PawPrint, LayoutDashboard, Store, LogOut, ShieldCheck, Search, Gem, Bird } from "lucide-react";

export const LOGO_URL = "/logo-wordmark.png";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-md bg-brand-cream/85 border-b border-brand-coral/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center" data-testid="nav-logo">
          <img src={LOGO_URL} alt="PetMachine Hub" className="h-9 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-1" data-testid="nav-links">
          <Link to="/prestadores" data-testid="nav-link-directory">
            <Button variant="ghost" className="text-brand-graphite hover:text-brand-coral">
              <Search className="w-4 h-4 mr-1.5" /> Encontrar serviços
            </Button>
          </Link>
          <Link to="/loja" data-testid="nav-link-shop">
            <Button variant="ghost" className="text-brand-graphite hover:text-brand-coral">
              <Store className="w-4 h-4 mr-1.5" /> Loja de Tags
            </Button>
          </Link>
          <Link to="/coleiras" data-testid="nav-link-collars">
            <Button variant="ghost" className="text-brand-graphite hover:text-brand-coral">
              <Gem className="w-4 h-4 mr-1.5" /> Coleiras
            </Button>
          </Link>
          <Link to="/aves" data-testid="nav-link-aves">
            <Button variant="ghost" className="text-brand-graphite hover:text-brand-coral">
              <Bird className="w-4 h-4 mr-1.5" /> Aves
            </Button>
          </Link>
          <Link to="/planos" data-testid="nav-link-plans">
            <Button variant="ghost" className="text-brand-graphite hover:text-brand-coral">
              <PawPrint className="w-4 h-4 mr-1.5" /> Planos
            </Button>
          </Link>
        </nav>
        <div className="flex items-center gap-2">
          {user ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" data-testid="nav-link-admin">
                  <Button variant="ghost" className="text-brand-coral">
                    <ShieldCheck className="w-4 h-4 mr-1.5" /> Admin
                  </Button>
                </Link>
              )}
              <Link to={user.role === "provider" ? "/painel" : "/app"} data-testid="nav-link-dashboard">
                <Button className="bg-brand-coral hover:bg-brand-coralDark text-white rounded-full px-5">
                  <LayoutDashboard className="w-4 h-4 mr-1.5" /> Minha conta
                </Button>
              </Link>
              <Button variant="ghost" size="icon" data-testid="nav-logout-btn"
                onClick={async () => { await logout(); navigate("/"); }}
                title="Sair">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="nav-link-login">
                <Button variant="ghost" className="text-brand-graphite">Entrar</Button>
              </Link>
              <Link to="/cadastro" data-testid="nav-link-register">
                <Button className="bg-brand-coral hover:bg-brand-coralDark text-white rounded-full px-5">
                  Cadastrar grátis
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
